import {apiFetch} from "../client";

// IP allowlist domain (admin)

export interface IPAllowlistItem {
    id: string;
    merchantId: string;
    merchantName: string;
    ip: string;
    comment: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface IPAllowlistResponse {
    enforced: boolean;
    items: IPAllowlistItem[];
}

export interface IPAllowlistEntryRequest {
    ip: string;
    merchantId: string;
    comment?: string | null;
}

export interface IPAllowlistIDResponse {
    id: string;
}

export interface IPAllowlistEnforcementResponse {
    enforced: boolean;
}

export function fetchIPAllowlist(token: string | null): Promise<IPAllowlistResponse> {
    return apiFetch<IPAllowlistResponse>("/ip-allowlist", token);
}

export function createIPAllowlistEntry(
    token: string | null,
    body: IPAllowlistEntryRequest,
): Promise<IPAllowlistIDResponse> {
    return apiFetch<IPAllowlistIDResponse>("/ip-allowlist", token, {
        method: "POST",
        body: JSON.stringify(body),
    });
}

export function updateIPAllowlistEntry(
    token: string | null,
    id: string,
    body: IPAllowlistEntryRequest,
): Promise<IPAllowlistIDResponse> {
    return apiFetch<IPAllowlistIDResponse>(`/ip-allowlist/${encodeURIComponent(id)}`, token, {
        method: "PATCH",
        body: JSON.stringify(body),
    });
}

export function deleteIPAllowlistEntry(token: string | null, id: string): Promise<void> {
    return apiFetch<void>(`/ip-allowlist/${encodeURIComponent(id)}`, token, {
        method: "DELETE",
    });
}

export function setIPAllowlistEnforcement(
    token: string | null,
    enforced: boolean,
): Promise<IPAllowlistEnforcementResponse> {
    return apiFetch<IPAllowlistEnforcementResponse>("/ip-allowlist/enforcement", token, {
        method: "PUT",
        body: JSON.stringify({enforced}),
    });
}
